import { Injectable, EventEmitter, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, interval, Subscription } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from "../../../app.config"
import { ApiResponse } from '../../../shared/models/api.response';
import { CompanyApi, CurrentLoggedInUserApi, RoleMangementApi } from "../../api.url";
import { UserPagePermissionModel } from '../../models/UserPagePermission';
import { CurrentLoggedInUserService } from '../../services/currentloggedinuser.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from '../../services/notification.service';
import { Role } from "../../../shared/models/useridentity.model";
import { VerifyCompanyCodeModel } from '../../../main/authentication/authentication.model';
import { environment } from 'environments/environment';
import { FuseAlertService } from '@fuse/components/alert';
import { AssessmentApi } from 'app/models/main/api.url';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionPopupComponent } from './subscription-model/subscription-popup/subscription-popup.component';
import { PaymentService } from 'app/main/payment/payment.service';


@Injectable({
  providedIn: 'root', // Makes it available globally
})
export class GlobalCompanyService implements OnDestroy {
  apiUrl = environment.apiBaseUrl
  //  notificationMsg: any;

  public pagePermissions: UserPagePermissionModel[];

  private globalCompanyId: BehaviorSubject<number>;

  private globalEntityId: BehaviorSubject<number>;

  notificationService: NotificationService;

  private parentAssessmentId: BehaviorSubject<number>;

  private categoryId: BehaviorSubject<number>;
  private categoryName: BehaviorSubject<string>;

  private companyPolicyDocumentId: BehaviorSubject<number>;
  private companyPolicyDocumentFileName: BehaviorSubject<string>;

  //private policyFlag: BehaviorSubject<boolean>;
  //private policyCommentFlag: BehaviorSubject<boolean>;
  //private relatedPolicyFlag: BehaviorSubject<boolean>;
  //private questionFlag: BehaviorSubject<boolean>;

  //globalCompanyId: number;
  globalCompanyName: string;
  regionName: string;
  districtName: string;
  dialogRef: any;
  assignedCompanyList: BehaviorSubject<any>;
  assignedRegionList: BehaviorSubject<any>;
  assignedDistrictList: BehaviorSubject<any>;

  isCompanyUser: BehaviorSubject<boolean>;

  isExpireSubscription: BehaviorSubject<boolean>;

  private subscriptionTimer: Subscription;
  private readonly TIMER_INTERVAL = 600000; //10m interval
  
  constructor(public http: HttpClient, private readonly appConfig: AppConfig,
    private readonly currentLoggedInUserService: CurrentLoggedInUserService,
    private readonly snb: MatSnackBar,public fuseAlertService: FuseAlertService,
      private _matDialog: MatDialog,private dialog: MatDialog,
      private paymentService : PaymentService
  ) {
    // this.startSubscriptionExpirationTimer();

    this.notificationService = new NotificationService(snb);
    this.globalCompanyId = new BehaviorSubject(0);
    this.assignedCompanyList = new BehaviorSubject(0);

    this.assignedRegionList = new BehaviorSubject(0);
    this.assignedDistrictList = new BehaviorSubject(0);

    this.parentAssessmentId = new BehaviorSubject(0);
    this.isCompanyUser = new BehaviorSubject(false);
    this.setAssignedCompanyList();
    this.isExpireSubscription = new BehaviorSubject(false);

    this.globalEntityId = new BehaviorSubject(0);
    //this.policyFlag = new BehaviorSubject(false);
    //this.policyCommentFlag = new BehaviorSubject(false);
    //this.relatedPolicyFlag = new BehaviorSubject(false);
    //this.questionFlag = new BehaviorSubject(false);
    this.categoryId = new BehaviorSubject(0);
    this.categoryName = new BehaviorSubject("");
    this.companyPolicyDocumentId = new BehaviorSubject(0);
    this.companyPolicyDocumentFileName = new BehaviorSubject("");
    
   
  }

  public startSubscriptionExpirationTimer(): void {
    this.expireSubscriptionNotication();
    
    if (this.subscriptionTimer) {
      this.subscriptionTimer.unsubscribe();
    }
    
    this.subscriptionTimer = interval(this.TIMER_INTERVAL).subscribe(() => {
      if (!this.dialogRef || !this.dialogRef.getState) {
        //this.expireSubscriptionNoticationPopup();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptionTimer) {
      this.subscriptionTimer.unsubscribe();
    }
  }

  set mainDocumentCategory(value) {
    this.categoryId.next(value);
  }

  get mainDocumentCategory(): any | Observable<number> {
    return this.categoryId.asObservable();
  }

  set mainDocumentCategoryName(value) {
    this.categoryName.next(value);
  }

  get mainDocumentCategoryName(): any | Observable<string> {
    return this.categoryName.asObservable();
  }

  set companyPolicyId(value) {
    this.companyPolicyDocumentId.next(value);
  }

  get companyPolicyId(): any | Observable<number> {
    return this.companyPolicyDocumentId.asObservable();
  }

  set companyPolicyFileName(value) {
    this.companyPolicyDocumentFileName.next(value);
  }

  get companyPolicyFileName(): any | Observable<string> {
    return this.companyPolicyDocumentFileName.asObservable();
  }


  set companyUser(value) {
    this.isCompanyUser.next(value);
  }

  get companyUser(): any | Observable<number> {
    return this.isCompanyUser.asObservable();
  }

  set expireSubscription(value) {
    this.isExpireSubscription.next(value);
  }

  get expireSubscription(): any | Observable<boolean> {
    return this.isExpireSubscription.asObservable();
  }


  /**
   * Set and get the config
   */
  set globalCompany(value) {
    this.globalCompanyId.next(value);
  }

  get globalCompany(): any | Observable<number> {
    return this.globalCompanyId.asObservable();
  }

  set globalEntity(value) {
    this.globalEntityId.next(value);
  }

  get globalEntity(): any | Observable<number> {
    return this.globalEntityId.asObservable();
  }

  set globalParentAssessment(value) {
    this.parentAssessmentId.next(value);
  }
  get globalParentAssessment(): any | Observable<number> {
    return this.parentAssessmentId.asObservable();
  }

  set assignedCompany(value) {
    this.assignedCompanyList.next(value);
  }

  get assignedCompany(): any | Observable<any> {
    return this.assignedCompanyList.asObservable();
  }

  set assignedRegion(value) {
    this.assignedRegionList.next(value);
  }

  get assignedRegion(): any | Observable<any> {
    return this.assignedRegionList.asObservable();
  }

  set assignedDistrict(value) {
    this.assignedDistrictList.next(value);
  }

  get assignedDistrict(): any | Observable<any> {
    return this.assignedDistrictList.asObservable();
  }

  /**
   * * Update Assigned Company List of Logged In users
   */
  setAssignedCompanyList() {
    
    if (!this.appConfig.isAuthenticated()) {
      this.assignedCompany = [];
      return;
    }

    this.http.get<ApiResponse>(this.apiUrl + CurrentLoggedInUserApi.getAssignedCompanyApiUrl).subscribe(res => {
      if (res.status === 1)
        this.companyUser = false;
      //this.fuseAlertService.show(res.message, res.status);

      if (res.status === 2)
        this.companyUser = true;
      //this.fuseAlertService.show(res.message, res.status);

      if (res.status === 1 || res.status === 2)
        //this.fuseAlertService.show(res.message, res.status);
        this.assignedCompany = res.data.companyList;
      this.assignedRegion = res.data.regionList;
      this.assignedDistrict = res.data.districtList;
    });
  }

  setAssignedCompanyByLoginUserList(userId: string) {

    let params = new HttpParams().set('userId', userId);

    this.http.get<ApiResponse>(this.apiUrl +CurrentLoggedInUserApi.getAssignedCompanyLoginTimeApiUrl, { params: params }).subscribe(res => {
      if (res.status === 1)
        this.companyUser = false;
      //this.fuseAlertService.show(res.message, res.status);

      if (res.status === 2)
        this.companyUser = true;
      //this.fuseAlertService.show(res.message, res.status);

      if (res.status === 1 || res.status === 2)
        this.assignedCompany = res.data.companyList;
      this.assignedRegion = res.data.regionList;
      this.assignedDistrict = res.data.districtList;
      //this.fuseAlertService.show(res.message, res.status);
    });
  }

  getAssignedCompanyToUser() {
    return this.http.get<ApiResponse>(this.apiUrl +CurrentLoggedInUserApi.getAssignedCompanyApiUrl);
  }

  setFavouriteCompany(model: any) {
    return this.http.post<ApiResponse>(this.apiUrl +CurrentLoggedInUserApi.setFavouriteCompanyApiUrl, model);
  }

  getEntitiesByCompany(companyId: number) {
    
    let params = new HttpParams().set('companyId', companyId.toString());
    return this.http.get<ApiResponse>(this.apiUrl +AssessmentApi.getEntitiesByCompany, { params: params });
  }

  expireSubscriptionNotication() {
 const user = JSON.parse(localStorage.getItem('userDetails') || '{}');
      const uid = user.userId;    

    this.paymentService.GetUserSubscriptionDetailsWithPages(uid).subscribe(res => {
      if (res.status === 1 && res.data != null) {
        const today = new Date();
        if (res.data && typeof res.data === 'object') {
          const plan = res.data;
          if (plan.planName === 'Free') {
            const trialStart = new Date(plan.trialPeriodFrom);
            const trialEnd = new Date(plan.trialPeriodTo);

            if (today >= trialStart && today <= trialEnd) {
              const message = `You have a Free plan, valid until ${trialEnd.toDateString()}.`;
              this.openPopupMessage(message, true, false);
            } else if (today > trialEnd) {
              const message = "Your Free plan has expired. To continue using the service, please purchase a plan.";
              this.openPopupMessage(message, true, true);
            }
          } else {
            // const message = `Your current active plan is ${plan.planName}.`;
            // this.openPopupMessage(message, false, false);
          }
        } else {
          console.error('Unexpected response format:', res.data);
        }

      }
    });
  }
  
  // expireSubscriptionNoticationPopup() {
  //   
  //   var authenticated = this.appConfig.isAuthenticated();
  //   if (authenticated) {
  //     this.currentLoggedInUserService.getCurrentLoggedInUserRole().subscribe(res => {
  //       if (res.status === 1) {
  //         var isClientAdmin = res.data.filter(x => x === Role.ClientAdmin);
  //         if (isClientAdmin.length > 0) {
  //           this.currentLoggedInUserService.getExpireSubscriptionOfLoggedInUser().subscribe(res => {
  //             if (res.status === 1 && res.data != null) {
  //               var message = "";
  //               if (res.data.noOfDay <= 0) {                  
  //                 message += "Your subscription has expired.";
  //               }
  //               if (message) {
  //                 this.openPopupMessage(message);
  //               }
  //             }
  //           });
  //         }
  //       }
  //     });
  //   }
  // }

openPopupMessage(message: string, isFreePlan: boolean, isPlanExpired: boolean, delay: number = 1000) {
  if (message && (!this.dialogRef || !this.dialogRef.getState)) {
    const bodyContent = document.querySelector('.content-wrapper');  
    if (bodyContent) {
      bodyContent.classList.add('blurred-background'); 
    }

  
    setTimeout(() => {
      const overlay = document.createElement('div');
      overlay.classList.add('overlay');
      document.body.appendChild(overlay);

      this.dialogRef = this.dialog.open(SubscriptionPopupComponent, {
        width: '450px',
        panelClass: 'app-policy-selection-entity-dailog-box',
        data: { message: message, isFreePlan: isFreePlan, isPlanExpired: isPlanExpired },
        disableClose: true,
      });

      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
        if (bodyContent) {
          bodyContent.classList.remove('blurred-background');  
        }
        document.body.removeChild(overlay); 
      });
    }, delay);  
  }
}

  
  
    AddGlobalSelectedId(selectedIdModel: any) {
      
        return this.http.post<ApiResponse>(this.apiUrl +CompanyApi.addGlobalSelectedApiUrl, selectedIdModel);
      }
  

      getGlobalSelectedId() {
    
        return this.http.get<ApiResponse>(this.apiUrl +CompanyApi.getGlobalSelectedApiUrl);
      }
      
  checkIsCompanySecurityCodeAvailable(companyId: string, userId: string) {
    let params = new HttpParams().set('companyId', companyId).set('userId', userId);
    return this.http.get<ApiResponse>(this.apiUrl +CurrentLoggedInUserApi.checkCompanySecurityCodeAvailableApiUrl, { params: params });
  }

  verifyCompanyCode(companyCodeModel: VerifyCompanyCodeModel) {
    return this.http.post<ApiResponse>(this.apiUrl +CurrentLoggedInUserApi.verifyCompanySecurityCodeApiUrl, companyCodeModel);
  }

  closeNotificaction() {
    this.notificationService.closeNotification();
  }
}